import React, { memo } from 'react'
import styles from './styles.module.scss'

interface GuestCountInputProps {
  value: string
  error: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSubmit: () => void
}

/* eslint-disable react/prop-types */
const GuestCountInput = memo<GuestCountInputProps>(({ value, error, onChange, onSubmit }) => {
  return (
    <div className={`${styles.guestCountInputContainer} ${error ? styles.hasError : ''}`}>
      <input
        className={styles.guestCountInput}
        placeholder="Your guest count"
        value={value}
        onChange={onChange}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        aria-label="Guest count"
        aria-invalid={!!error}
        aria-describedby={error ? 'guest-count-error' : undefined}
      />
      {error && (
        <div id="guest-count-error" className={styles.errorMessage} role="alert">
          {error}
        </div>
      )}
    </div>
  )
})

GuestCountInput.displayName = 'GuestCountInput'

export default GuestCountInput
